import { render, staticRenderFns } from "./NaverLoginComponent.vue?vue&type=template&id=10ecc9ea&scoped=true&"
import script from "./NaverLoginComponent.vue?vue&type=script&lang=js&"
export * from "./NaverLoginComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ecc9ea",
  null
  
)

export default component.exports